import { Card, Col, Row, Spin } from 'antd';

import { Viewport } from 'components/ViewportProvider';
import React from 'react';
import styled from 'styled-components';
import media from 'utils/mediaStyle';
import FFMNoteDesktopTable from './FFMNoteDesktopTable';
import FulfillmentNoteSummary from './FulfillmentNoteSummary';
import FFMNoteMobileTable from './FFMNoteMobileTable';
import { MoneySection } from 'components/Order/OrderSummary';
import InvoiceInfo from 'components/Order/InvoiceInfo';

const Container = styled.section``;

const OrderRow = styled(Row)`
  margin-bottom: 15px;
`;

const OrderCol = styled(Col)`
  padding: 16px;
`;
const TableContainer = styled.div`
  .ant-table-body table {
    display: flex;
    flex-direction: column;
    th {
      text-transform: capitalize;
    }
  }
  .ant-table-body .ant-table-row {
    display: block;
    width: 100%;
  }
  .ant-table-row td {
    display: block;
    width: 100%;
  }
  ${media.sm`
    .ant-table-body table {
      display: table;
      flex-direction: column;
    }
    .ant-table-body .ant-table-row {
      display: table-row;
    }
    .ant-table-row td {
      display: table-cell;
      width: 0;
    }
  `};
`;
const FulfillmentNoteCard = styled.div`
  border-radius: 8px;
  background-color: #fff;
  .ant-card-body {
    padding: 0 !important;
  }
`;
export const OrderInfoSection = styled.div<{ isMobileSize?: boolean }>`
  padding: 12px;
  display: flex;
  gap: 6px;
  align-items: ${({ isMobileSize }) => (isMobileSize ? 'flex-start' : 'center')};
  border-radius: 6px;
  background-color: #fffbe6;
  margin-bottom: 16px;
  ${({ isMobileSize }) => isMobileSize && `margin: 8px 12px`};
`;

interface FulfillmentNoteDetailProps {
  fulfillmentNote: any;
}

class FulfillmentNoteDetail extends React.Component<FulfillmentNoteDetailProps, any> {
  public render() {
    const { fulfillmentNote } = this.props;
    const { fulfillmentNote: fulfillmentNoteData, loading } = fulfillmentNote;
    console.log('fulfillmentNote', fulfillmentNote);
    return (
      <Viewport.Consumer>
        {({ width }) => {
          const isMobileSize = width < 768;
          return (
            <Spin spinning={loading}>
              <Container>
                <FulfillmentNoteCard bordered={false}>
                  <FulfillmentNoteSummary fulfillmentNote={fulfillmentNoteData} isMobileSize={isMobileSize} />
                </FulfillmentNoteCard>
                <div style={{marginTop: 12}}>
                  <InvoiceInfo invoice={fulfillmentNote?.fulfillmentNote?.invoice} />
                </div>
                {fulfillmentNoteData.fulfillmentNoteId ? (
                  <Card bordered={false} style={{ marginTop: 12 }} bodyStyle={{ padding: 0 }}>
                    {isMobileSize ? (
                      <>
                        <TableContainer>
                          <FFMNoteMobileTable fulfillmentNote={fulfillmentNoteData} />
                        </TableContainer>

                        <OrderRow gutter={8}>
                          <OrderCol lg={24} sm={24} xs={24} style={{ paddingBottom: 0 }}>
                            <MoneySection hideInfoText={true} isMobileSize={isMobileSize} order={fulfillmentNoteData} />
                          </OrderCol>
                        </OrderRow>
                      </>
                    ) : (
                      <FFMNoteDesktopTable fulfillmentNote={fulfillmentNoteData} />
                    )}
                  </Card>
                ) : null}
              </Container>
            </Spin>
          );
        }}
      </Viewport.Consumer>
    );
  }
}

export default FulfillmentNoteDetail;
